import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  LOW: {
    color: theme.palette.priorities.low,
  },
  HIGH: {
    color: theme.palette.priorities.high,
  },
  MEDIUM: {
    color: theme.palette.priorities.medium,
  },
  URGENT: {
    color: theme.palette.priorities.urgent,
  },
  icon: {
    fontSize: 13,
    marginRight: 10,
  },
}));

export default useStyles;
